export default __webpack_public_path__ + "static/media/roadmap.3caa9ba8.jpeg";